// extracted by mini-css-extract-plugin
module.exports = {"footer":"index_footer_qx5I-","footerInner":"index_footerInner_2PLfK","logo":"index_logo_6z0cV"};